import { jsx as y } from "react/jsx-runtime";
import { createContext as b, useRef as l, useMemo as v, useEffect as h, useState as k, useContext as P, useCallback as x } from "react";
import { i as j, C as p, d as q } from "./index-BC4rIK6w.js";
function E(e) {
  const r = l(e), t = l(0);
  return j(e, r.current) || (r.current = e, t.current += 1), v(() => r.current, [t.current]);
}
function L(e, r) {
  return h(e, E(r));
}
const C = b(null);
function R({
  children: e,
  locale: r,
  space: t,
  environment: i,
  debugMode: o = !1,
  enableInspectorMode: s = !0,
  enableLiveUpdates: f = !0,
  targetOrigin: u,
  experimental: n
}) {
  if (!r)
    throw new Error(
      'ContentfulLivePreviewProvider has to be called with a locale property (for example: `<ContentfulLivePreviewProvider locale="en-US">{children}</ContentfulLivePreviewProvider>`'
    );
  p.init({
    locale: r,
    space: t,
    environment: i,
    debugMode: o,
    enableInspectorMode: s,
    enableLiveUpdates: f,
    targetOrigin: u,
    experimental: n
  });
  const c = v(
    () => ({
      locale: r,
      space: t,
      environment: i,
      debugMode: o,
      enableInspectorMode: s,
      enableLiveUpdates: f,
      targetOrigin: u
    }),
    [r, t, i, o, s, f, u]
  );
  return /* @__PURE__ */ y(C.Provider, { value: c, children: e });
}
function a(e, r, t = !1) {
  const [i, o] = k({ data: e, version: 1 }), s = l(e), f = l(q(o)), u = P(C), n = typeof r == "object" ? r : { locale: r, skip: t }, c = v(() => u && !u.enableLiveUpdates || n.skip ? !1 : !!(Array.isArray(e) && e.length || e && typeof e == "object" && Object.keys(e).length), [u, n.skip, e]);
  return L(() => {
    if (s.current !== e && (o({ data: e, version: 1 }), s.current = e), !!c)
      return p.subscribe("edit", {
        data: e,
        locale: n.locale,
        query: n.query,
        callback: (m) => {
          f.current((w) => ({ data: m, version: w.version + 1 }));
        }
      });
  }, [e, c, n.locale, n.query]), i.data;
}
function z(e) {
  const r = P(C);
  return x(
    (t) => r != null && r.enableInspectorMode ? p.getProps({ ...e, ...t }) : null,
    [r == null ? void 0 : r.enableInspectorMode, e]
  );
}
export {
  R as ContentfulLivePreviewProvider,
  z as useContentfulInspectorMode,
  a as useContentfulLiveUpdates,
  L as useDeepCompareEffectNoCheck,
  E as useDeepCompareMemoize
};
//# sourceMappingURL=react.js.map
